import {NotificationType} from "./../../Scalesoft.Shared.FrontEnd/Scripts/Enums/NotificationType";
import GuiCommonShared from "./../../Scalesoft.Shared.FrontEnd/Scripts/GuiCommonShared";
import NotificationConfiguration from "./../../Scalesoft.Shared.FrontEnd/Scripts/NotificationConfiguration";

interface ICheckElementsContainer {
    firstElement: HTMLInputElement;
    secondElement: HTMLInputElement;
    message: string;
    notificationContainer?: JQuery;
    compareFunction?: (firstInput: HTMLInputElement, secondInput: HTMLInputElement) => boolean;
}

export default class InputEqualityChecker {
    private readonly guiCommon: GuiCommonShared;
    private readonly globalNotificationContainer: JQuery = null;
    private checkElements: ICheckElementsContainer[] = [];

    constructor(
        guiCommon: GuiCommonShared,
        globalNotificationContainer?: JQuery,
    ) {
        this.guiCommon = guiCommon;
        this.globalNotificationContainer = globalNotificationContainer;
    }

    public elementsToCheckAdd(firstSelector: string,
                              secondSelector: string,
                              message: string,
                              notificationContainer?: JQuery,
                              compareFunction?: (firstInput: HTMLInputElement, secondInput: HTMLInputElement) => boolean,
                              autoValidate = true,
    ): void {
        const firstEl = document.querySelector(firstSelector);
        const secondEl = document.querySelector(secondSelector);

        if (firstEl === null || secondEl === null) {
            return;
        }

        const checkContainer: ICheckElementsContainer = {
            firstElement: firstEl as HTMLInputElement,
            secondElement: secondEl as HTMLInputElement,
            message,
            notificationContainer,
            compareFunction,
        };

        this.checkElements.push(checkContainer);

        if (autoValidate) {
            this.addEventListener(checkContainer);
        }
    }

    public validate(): boolean {
        const globalMessages: string[] = [];
        let hasAnyError = false;

        if (this.globalNotificationContainer) {
            this.globalNotificationContainer.empty();
        }

        for (const checkElement of this.checkElements) {
            hasAnyError = this.validateSingle(checkElement, globalMessages, hasAnyError);
        }

        if (this.globalNotificationContainer) {
            this.globalNotificationContainer.empty();
            if (globalMessages.length) {
                this.formNotification(globalMessages, this.globalNotificationContainer.get(0));
            }
        }

        return hasAnyError;
    }

    private addEventListener(checkContainer: ICheckElementsContainer): void {
        const first = checkContainer.firstElement;
        const second = checkContainer.secondElement;

        const firstInitialValue = first.value;
        const secondInitialValue = second.value;

        let firstEdited = false;
        let secondEdited = false;

        const checkSingleCallback = () => {
            if ((firstInitialValue || firstEdited) && (secondInitialValue || secondEdited)) {
                this.validateSingle(checkContainer);
            }
        };

        first.addEventListener("change", () => {
            firstEdited = true;
            checkSingleCallback();
        });

        second.addEventListener("change", () => {
            secondEdited = true;
            checkSingleCallback();
        });
    }

    private validateSingle(checkElement: ICheckElementsContainer, globalMessages: string[] = [], hasAnyError = false): boolean {
        const notificationContainers = checkElement.notificationContainer
            ? checkElement.notificationContainer
            : this.globalNotificationContainer;

        const containerIsLocal = !!checkElement.notificationContainer;

        if (!this.doValidityCheck(checkElement)) {
            hasAnyError = true;
            if (containerIsLocal) {
                notificationContainers.each((index, element) => {
                    element.innerHTML = "";
                    this.formNotification(checkElement.message, element);
                });

            } else {
                globalMessages.push(checkElement.message);
            }
        } else {
            if (containerIsLocal) {

                notificationContainers.each((index, element) => {
                    element.innerHTML = "";
                });
            }
        }

        return hasAnyError;
    }

    private formNotification(message: string | string[], container: HTMLElement): void {
        const jqNotificationContainer = jq(container);
        const messages = Array.isArray(message) ? message : [message];

        const notificationConfiguration = new NotificationConfiguration({
            container: jqNotificationContainer,
            messages,
            notificationType: NotificationType.Warning,
        });
        this.guiCommon.showNotification(notificationConfiguration);
    }

    private doValidityCheck(checkContainer: ICheckElementsContainer): boolean {
        if (checkContainer.compareFunction !== undefined) {
            return checkContainer.compareFunction(checkContainer.firstElement, checkContainer.secondElement);
        } else {
            const firstElementValue = checkContainer.firstElement.value.replace(/[^\d]/g, "");
            const secondElementValue = checkContainer.secondElement.value.replace(/[^\d]/g, "");
            if (firstElementValue === "" || secondElementValue === "") {
                return true;
            }

            if (firstElementValue === secondElementValue) {
                return true;
            }

            return false;
        }
    }
}
